import {
  Button,
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import { ChangeEvent, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { UserProps, UserToken } from "../../context/hooks/useAuth";
import InputPassword from "../../components/Inputs/InputPassword";
import InputEmailLogin from "../../components/Inputs/InputEmailLogin";
import "./Login.css";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import { UserTypeContext } from "../../context/UserTypeContext";
import { jwtDecode } from "jwt-decode";
import ModaMobileLogin from "../../components/ModaMobileLogin/ModaMobileLogin";

const Login = () => {
  const { handleLogin, objUserTk } = useContext(AuthContext);
  const { getUsersById } = useContext(UserTypeContext);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 650);

  const [login, setLogin] = useState<UserProps>({
    password: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);

  const handleLoginClick = async () => {
    setLoading(true);
    await handleLogin(login);
    setLoading(false);
    const user = jwtDecode(localStorage.getItem("token") || "") as UserToken;

    await getUsersById(user.UserId);
  };

  const handleInputChange = (valueAtt: any, name: string) => {
    setLogin((prevLogin) => ({
      ...prevLogin,
      [name]: valueAtt,
    }));
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      handleLoginClick();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 650);
      setIsMobileView(true);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* <ModaMobileLogin /> */}

      <Row className="justify-content-center">
        <Col
          lg="10"
          md="7"
          className="d-flex"
          style={{
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
          }}
        >
          <img
            style={{ width: "50%" }}
            alt="Logo"
            src={require("../../assets/img/brand/logoendocpng.png")}
          />

          <div className="d-flex" style={{ flexDirection: "column" }}>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "5.76px",
                color: "#002231",
                opacity: 1,
                fontSize: "24px",
              }}
            >
              O Endoc facilita sua vida!
            </span>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "2.24px",
                color: "#002231",
                opacity: 0.5,
                fontSize: "11px",
              }}
            >
              GESTÃO E ASSINATURA DE CONTRATOS DE MANEIRA FÁCIL E SEGURA
            </span>
          </div>

          <div className="px-lg-5" style={{ width: "84%" }}>
            <form
              role="form"
              style={{
                gap: "27px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <InputEmailLogin
                name="email"
                value={login.email}
                handleChange={handleInputChange}
                label={"E-mail"}
              />

              <InputPassword
                name="password"
                value={login.password}
                handleChange={handleInputChange}
                label={"Senha"}
              />
            </form>

            <span
              onClick={() => (window.location.href = "/auth/forgot-password")}
              style={{
                marginTop: "5px",
                display: "flex",
                justifyContent: "end",
                textAlign: "right",
                letterSpacing: "0.16px",
                color: "#6A6F7D",
                opacity: 1,
                fontSize: "11px",
                cursor: "pointer",
              }}
            >
              Esqueceu sua senha?
            </span>

            <div className="text-center d-flex justify-content-center">
              <Button
                onClick={handleLoginClick}
                className="my-4 button-login"
                type="button"
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm">Loading...</Spinner>
                ) : (
                  <Person2OutlinedIcon />
                )}{" "}
                FAZER LOGIN
              </Button>
            </div>
            <div className="text-center d-flex justify-content-center">
              <Button
                onClick={() => (window.location.href = "/auth/register")}
                className="my-2 button-login"
                type="button"
                style={{
                  backgroundColor: "#F9B233",
                  border: "none",
                  color: "#fff",
                }}
              >
                🚀 CADASTRE-SE CLICANDO AQUI
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Login;
